module.exports = __webpack_public_path__ + "static/auto-icon-50853d915566ee219fd1c5413dc16fb8.png";